import React from 'react'
import { strings } from '../../../localization/strings'
import { makeStyles, Menu, MenuItem } from '@material-ui/core'

const useStyles = makeStyles({
    menuTitle: {
        color: '#f7b500',
        opacity: '1 !important',
        borderBottom: '.5px solid #f7b500',
    },
    menuItem: {
        width:'250px',
        borderBottom: '.5px solid #c2bfbf',
        '& span': {
            padding:'5px 10px',
        },
    },
    seeAll: {
        color: '#f7b500',
        justifyContent: 'right',
        width:'250px',
    },
    title:{
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }
})

const NewsResume = (props) => {
    const { news, openNewsPanel, anchorEl, handleClick} = props
    const styles = useStyles()

  return (
    <Menu 
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClick}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        getContentAnchorEl={null}
        transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
    >
        <MenuItem 
            className={styles.menuTitle}
            disabled
        >
            {news.length ? `${strings.newsResume.newNews}` : `${strings.newsResume.noNews}`}
        </MenuItem>
        { news.slice(0,3).map((oneNew) => {
            return <MenuItem className={styles.menuItem} key={oneNew.id} onClick={openNewsPanel}>
                <span className={styles.title}>
                    {oneNew.title}
                </span>
            </MenuItem>
        }) 
        }
        <MenuItem 
            className={styles.seeAll} 
            onClick={openNewsPanel}
        >
            {strings.newsResume.seeAll}
        </MenuItem>
    </Menu>
  )
}

export default NewsResume
